import { type FC } from 'react';

import { BentoLayoutSize } from 'common/bento/lib/layout';
import useLayoutSizeQuery from 'common/bento/lib/layout/useLayoutSizeQuery';
import Button, { type ButtonProps } from 'components/_core/Button';
import IconButton from 'components/_core/IconButton';

import locales from './locales';

const CloseButton: FC<Omit<ButtonProps, 'children'>> = (props) => {
  const isLarge = useLayoutSizeQuery(BentoLayoutSize.lg);

  return isLarge ? (
    <Button
      icon="cross"
      iconPosition="left"
      size="sm"
      variant="tertiary"
      {...props}
    >
      {locales.close}
    </Button>
  ) : (
    <IconButton
      aria-label={locales.close}
      icon="cross"
      variant="inline-secondary"
      {...props}
    />
  );
};

export default CloseButton;
